import { Utils } from '../libraries';
import { EnumApiAuth } from './auth';
import { EnumApiLegal } from './legal';
import { EnumApiWechat } from './wechat';
export const EnumAPI = {
    ...new EnumApiWechat(),
    ...new EnumApiAuth(),
    ...new EnumApiLegal(),
};
Utils.toReadonly(EnumAPI);
